import { render, staticRenderFns } from "./S2STurnOsMakeIn.vue?vue&type=template&id=96d203de"
import script from "./S2STurnOsMakeIn.vue?vue&type=script&lang=js"
export * from "./S2STurnOsMakeIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports